export default [
  {
    key: 'userId',
    label: 'field.operator',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'chatOperator',
    selectionKey: 'id',
    selectionLabel: 'name',
    cols: 12,
  },
]
